import Vue from 'vue'
import * as moment from 'moment'

Vue.filter('formatDate', function (value, format = 'MM/DD/YYYY') {
  if (value) {
    if (value instanceof moment) {
      return value.format(format)
    }
    return moment(String(value)).format(format)
  }
})

Vue.filter('formatUtcDate', function (value, format = 'MM/DD/YYYY') {
  if (value) {
    if (value.length && value[value.length - 1] === 'Z') {
      return moment(String(value)).format(format)
    }
    return moment(`${value}Z`).format(format)
  }
})

Vue.filter('formatUtcTime', function (value, format = 'h:mma') {
  if (value) {
    if (value.length && value[value.length - 1] === 'Z') {
      return moment(String(value)).format(format)
    }
    return moment(`${value}Z`).format(format)
  }
})

Vue.filter('formatCurrency', function (value) {
  if (typeof value !== 'number') {
    return value
  }
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  })
  return formatter.format(value)
})

// Available sizes in pixel width (Height will vary due to maintaining aspect)
// 'XS' - 100
// 'S' - 200
// 'M' - 400
// 'L' - 600
// 'XL' - 800
// 'O' (Original)
Vue.filter('fullImagePath', function (value, size) {
  if (!value) {
    return null
  }
  if (value.startsWith('http')) {
    return value
  }
  size = size || 'L'
  return process.env.VUE_APP_CDN_URL + value + size + '.png'
})

Vue.filter('formatPhone', function (value) {
  const cleaned = ('' + value.toString()).replace(/\D/g, '')
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
  if (match) {
    const intlCode = (match[1] ? '+1 ' : '')
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
  }
  return value // Failed, just return raw string
})

/** Used to break new phone numbers to a new line if there are multiple */
Vue.filter('phoneBreak', function (val) {
  if (!val) return ''
  return val.replace(/[0-9]{4}[\s]+/g, '$&\n')
})

Vue.filter('uppercase', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.toUpperCase()
})

Vue.filter('phoneHref', function (value) {
  // A360 wants all phone number hrefs in the format +11231231234 (11 digits with country code)
  if (!value) return ''
  let str = value.replace(/\D+/g, '')
  if (str.length <= 10) {
    // add country code if it does not have it
    str = '+1' + str
  }
  if (!str.startsWith('+')) {
    str = '+' + str
  }
  return 'tel:' + str
})
